var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile",class:[
  _vm.getPageLayout =='centre'? 'justify-center': '',
  _vm.getPageLayout =='left'? 'layout1' : '',
  _vm.getPageLayout =='right'? 'layout1 layout1-right' : ''
]},[_c('div',{class:[
    _vm.getPageLayout =='centre'? 'layout1 layout1-center mb-4' : '' ]},[_c('div',{staticClass:"main_conainer"},[_c('div',{staticClass:"main-header"},[_c('img',{staticClass:"main-logo",attrs:{"src":_vm.navLogo}}),_c('h4',{staticClass:"mt15 col_secondary fw400 fs24",domProps:{"innerHTML":_vm._s(_vm.setTitle)}})]),_c('div',{staticClass:"main-body mt30"},[_vm._t("form")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }